import { config } from "../app-env/common";
import { onApiError } from "../error";
import { state } from "../state";
import { put } from "./client";

/**
 * @param {string} email
 * @param {string} password
 */
async function signIn(email, password) {
	const res = await put("/sign-in", {
		body: JSON.stringify({
			Email: email,
			Password: password,
			ClientTheme: config.brand,
		}),
	});

	if (!res.ok) throw await onApiError(res);

	/** @type {Auth} */
	const { User, Token } = await res.json();
	await state.setUser(User);
	await state.setToken(Token);
}

export { signIn };
